// extracted by mini-css-extract-plugin
module.exports = {"moreLink":"MoreLink-module--more-link--2oTfr","moreLinkGreen":"MoreLink-module--more-link-green--33wAA","moreLinkBlue":"MoreLink-module--more-link-blue--1rkTW"};